// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"76f9d31b","111":"39b0bac1","136":"bf72ec42","171":"2fada31c","250":"4f0a2e39","431":"462b2a31","442":"e58f7993","625":"66ac7b0e","864":"d42b06fc","935":"b8edd24c","955":"4f7f6d9d","966":"f3cd1bea","996":"4888176a"}[chunkId] + ".chunk.js";
};